import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../const'; 
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar'; 

const API_BASE = `${BASE_URL}/max-summary`;

const SummarySection = ({ title, apiPath, buttonText, onButtonClick }) => {
  const [lastDate, setLastDate] = useState('');
  const [categoryData, setCategoryData] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const storeId = localStorage.getItem("store");
  
      if (!token || !storeId) {
        console.warn("Missing token or store_id in localStorage");
        setIsLoading(false);
        return;
      }
      
      try {
        const response = await axios.get(`${API_BASE}/${apiPath}/`, {
          headers: {
            Authorization: `Token ${token}`,
            Store: storeId 
          }
        });
  
        const data = response.data;
        setLastDate(data.date);
        setCategoryData(data.summary);
        setTotalQty(data.summary.reduce((sum, item) => sum + item.qty, 0));
      } catch (err) {
        console.error(`Error fetching ${apiPath} summary:`, err);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchData();
  }, [apiPath]);

  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow duration-200">
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-800 flex items-center">
            {title.includes('📦') && <span className="mr-2">📦</span>}
            {title.includes('📥') && <span className="mr-2">📥</span>}
            {title.replace(/[📦📥]/g, '').trim()}
          </h2>
          <span className="text-sm font-medium text-gray-500">
            {isLoading ? 'Loading...' : `Updated: ${lastDate || 'N/A'}`}
          </span>
        </div>

        {isLoading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
          </div>
        ) : (
          <>
            <div className="max-h-48 overflow-y-auto mb-4 border rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <tbody className="bg-white divide-y divide-gray-200">
                  {categoryData.map((item, idx) => (
                    <tr key={idx}>
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                        {item.sku_category}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 text-right">
                        {item.qty}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="flex items-center justify-between mt-4">
              <div>
                <span className="text-sm font-medium text-gray-500">Total:</span>
                <span className="ml-2 text-lg font-bold text-gray-800">{totalQty}</span>
              </div>
              <button
                onClick={onButtonClick}
                className={`px-4 py-2 rounded-lg font-medium text-white transition-colors ${
                  apiPath === 'inventory' 
                    ? 'bg-blue-600 hover:bg-blue-700' 
                    : 'bg-green-600 hover:bg-green-700'
                }`}
              >
                {buttonText}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar title="Dashboard" />
      
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Inventory Dashboard</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <SummarySection
            title="📦 Inventory Summary"
            apiPath="inventory"
            buttonText="Start Inventory Count"
            onButtonClick={() => navigate('/inventory-count?mode=inventory')}
          />
          <SummarySection
            title="📥 GRN Summary"
            apiPath="grn"
            buttonText="Start GRN Processing"
            onButtonClick={() => navigate('/inventory-count?mode=grn')}
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;